import produce from "immer";
import find from "lodash/find";
import pull from "lodash/pull";
import { CustomizationState } from "../";
import { ContentEditableText } from "../../../types/customization/content";
import {
  findEditableTextDefinition,
  findPageAndDefinition,
} from "../../../utils/customization/finders";

export interface ChangeEditableTextElementContentAction {
  type: "changeEditableTextElementContent";
  pageKey: string;
  editableTextKey: string;
  content: string;
}

export function changeEditableTextElementContent(
  state: CustomizationState,
  action: ChangeEditableTextElementContentAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { editableTextKey, pageKey, content } = action;

    const { page, pageDefinition } = findPageAndDefinition(
      pageKey,
      draftState.template,
      draftState.content
    );

    const element: ContentEditableText | undefined = find(
      page.editableTexts,
      (editableText) => editableText.editableTextKey === editableTextKey
    );
    if (!element) {
      if (content !== "") {
        page.editableTexts.push({
          content,
          editableTextKey,
          fontKey: draftState.ui.defaultFontKey || draftState.template.fontDefinitions[0].key,
        });
      }
    } else {
      if (content === "") {
        const elementDefinition = findEditableTextDefinition(editableTextKey, pageDefinition);

        if (elementDefinition.preFilledText?.length) {
          element.content = "";
        } else {
          pull(page.editableTexts, element);
        }

        if (element.fontKey) {
          draftState.ui.defaultFontKey = element.fontKey;
        }
      } else {
        element.content = content;
      }
    }
  });
}
